import { z } from 'zod';
import { AuditedFields, CursorPageQuery, Uuid, Version } from './common.js';
import { PERMISSION_CODES } from './permissions.js';
export const PermissionCodeSchema = z
    .string()
    .refine((v) => PERMISSION_CODES.includes(v), 'Permission inconnue');
export const Role = z
    .object({
    id: Uuid,
    code: z.string(),
    name: z.string(),
    description: z.string().nullable(),
    isSystem: z.boolean(),
    permissions: z.array(z.string()),
    usersCount: z.number().int().nonnegative(),
    version: Version,
})
    .merge(AuditedFields);
export const CreateRoleRequest = z.object({
    code: z.string().regex(/^[a-z][a-z0-9_]{2,40}$/, 'Code en minuscules, chiffres et _'),
    name: z.string().min(2).max(80),
    description: z.string().max(500).optional(),
    permissions: z.array(PermissionCodeSchema).min(1),
});
export const UpdateRoleRequest = z.object({
    name: z.string().min(2).max(80).optional(),
    description: z.string().max(500).nullable().optional(),
    permissions: z.array(PermissionCodeSchema).min(1).optional(),
    version: Version,
});
export const ListRolesQuery = CursorPageQuery;
export const PermissionCatalogEntry = z.object({
    code: z.string(),
    domain: z.string(),
    description: z.string(),
    sensitive: z.boolean(),
    highPrivilege: z.boolean(),
});
//# sourceMappingURL=roles.js.map